<template>
  <div>
    <h1>{{$route.meta.title}}</h1>

    <ul>
      <li v-for="p of periods" :key="p.Id">
        <label>
          <input type="checkbox" :checked="p.IsImported" @change="update(p.Id)" />
          [{{p.Id}}] {{p.Libelle + " " + p.Year}}
        </label>
      </li>
    </ul>
  </div>
</template>

<script>
  import { getAutoImport, toggleAutoImport } from "@/utils/period";

  export default {
    name: "AutoImport",
    data() {
      return {
        periods: []
      }
    },
    mounted() {
      getAutoImport().then(res => this.periods = res);
    },
    methods: {
      update(periodId) {
        toggleAutoImport(periodId).then(() => {
          getAutoImport().then(res => this.periods = res);
        })
      }
    }
  }
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/pages/Admin/AutoImport.vue